import { render } from "./EditProfileForm.vue?vue&type=template&id=7127cbf8"
import script from "./EditProfileForm.vue?vue&type=script&lang=js"
export * from "./EditProfileForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__